import React, { ReactNode } from 'react'
import { GridColumnHeaderParams } from '@mui/x-data-grid-pro'
import styled from 'particles/themes/styled'
import Tooltip from '@mui/material/Tooltip'
import Text from 'particles/Text'

export const getMultilineHeader = (params: GridColumnHeaderParams, width: number) => {
    return (
        <Tooltip title={params.colDef.headerName ?? ''}>
            <MultilineHeader width={width}>{params.colDef.headerName}</MultilineHeader>
        </Tooltip>
    )
}

const MultilineHeader = styled.span<{ width: number }>`
    display: block;
    width: ${({ width }) => width}px;
    max-height: 36px;
    white-space: normal;
    word-wrap: break-word;
    line-height: 1.2em;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
`

interface ReportSummaryContainerProps {
    title: string
    description?: string
    children: ReactNode
}

export const ReportSummaryContainer: React.FC<ReportSummaryContainerProps> = ({ title, description, children }) => {
    return (
        <CardContainer>
            <div className="title-description-container">
                <Text scale="H4" color="primary">
                    {title}
                </Text>
                {description && (
                    <Text scale="bodyS400" color="secondary">
                        {description}
                    </Text>
                )}
            </div>
            {children}
        </CardContainer>
    )
}

export const CardContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: fit-content;
    width: 100%;
    box-sizing: border-box;
    padding: 12px 12px 16px;
    border-radius: 4px;
    gap: ${({ theme }) => theme.spacing[400]};
    align-self: stretch;
    background-color: ${({ theme }) => theme.colors.background.secondary};

    .title-description-container {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        align-self: stretch;
        gap: ${({ theme }) => theme.spacing[200]};
    }
`
